"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextSelectorContext = void 0;

var react_1 = __importStar(require("react"));

var rc_tooltip_1 = __importDefault(require("rc-tooltip"));

var react_material_icon_1 = __importDefault(require("@material/react-material-icon"));

var RichTextContext_1 = require("../RichTextContext");

var NodeSelectorButton = function NodeSelectorButton(props) {
  var Button = RichTextContext_1.getUI(RichTextContext_1.useUI()).Button;
  return react_1.default.createElement(Button, __assign({}, props), react_1.default.createElement(react_material_icon_1.default, {
    className: "bl-material-icons",
    icon: "more_horiz"
  }));
};

NodeSelectorButton.displayName = 'NodeSelectorButton';

var CloseBtn = function CloseBtn(props) {
  var CloseButton = RichTextContext_1.getUI(RichTextContext_1.useUI()).CloseButton;
  return react_1.default.createElement(CloseButton, __assign({}, props), react_1.default.createElement(react_material_icon_1.default, {
    icon: "cancel"
  }));
};

exports.TextSelectorContext = react_1.default.createContext({
  onClose: function onClose() {}
});

var TextSelectorButton = function TextSelectorButton(_a) {
  var children = _a.children;

  var _b = __read(react_1.useState(false), 2),
      visible = _b[0],
      setVisible = _b[1];

  var _c = RichTextContext_1.getUI(RichTextContext_1.useUI()),
      Overlay = _c.Overlay,
      TextSelectorWrapper = _c.TextSelectorWrapper;

  var textSelectorContextValue = {
    onClose: function onClose() {
      return setVisible(false);
    }
  };
  return react_1.default.createElement(rc_tooltip_1.default, {
    visible: visible,
    placement: "topLeft",
    overlayStyle: {
      opacity: 1
    },
    align: {
      offset: [-40, -10]
    },
    overlay: function overlay() {
      return react_1.default.createElement(Overlay, null, react_1.default.createElement(exports.TextSelectorContext.Provider, {
        value: textSelectorContextValue
      }, react_1.default.createElement(CloseBtn, {
        onMouseDown: function onMouseDown() {
          return setVisible(false);
        }
      }), react_1.default.createElement(TextSelectorWrapper, null, children)));
    }
  }, react_1.default.createElement(NodeSelectorButton, {
    onMouseDown: function onMouseDown() {
      setVisible(true);
    }
  }));
};

TextSelectorButton.displayName = 'TextSelectorButton';
exports.default = TextSelectorButton;